import "@/App.css";
import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation, Link } from "react-router-dom";
import { SettingsProvider } from "@/context/SettingsContext";
import { AuthProvider } from "@/context/AuthContext";
import WhatsNewFAB from "@/components/WhatsNewFAB";
import TopBar from "@/components/TopBar";
import Home from "@/pages/Home";
import Projects from "@/pages/Projects";
import ProjectDetail from "@/pages/ProjectDetail";
import Journal from "@/pages/Journal";
import JournalDetail from "@/pages/JournalDetail";
import Contact from "@/pages/Contact";
import Experience from "@/pages/Experience";
import Bespoke from "@/pages/Bespoke";
import Gifting from "@/pages/Gifting";
import GiftingCategory from "@/pages/GiftingCategory";
import GiftingCurated from "@/pages/GiftingCurated";
import HiddenRatio from "@/pages/HiddenRatio";
import UnderstandingYu from "@/pages/UnderstandingYu";
import Login from "@/pages/Login";
import { Terms, Privacy, Cookies, ServiceTerms, IntellectualProperty } from "@/pages/Legal";

function ScrollToTop() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname, search]);
  return null;
}

function NotFound() {
  return (
    <div className="min-h-screen bg-lux-bg">
      <TopBar />
      <div className="w-full max-w-[1200px] mx-auto px-6 md:px-12 pt-40 md:pt-52 pb-32">
        <p className="text-[11px] tracking-[0.28em] uppercase text-lux-accent">· 404 ·</p>
        <h1 className="font-serif text-lux-ink font-light tracking-tight leading-none mt-2 text-5xl md:text-7xl">Page not found.</h1>
        <p className="text-base text-lux-sec font-light mt-5">The page you’re looking for doesn’t exist or has moved.</p>
        <Link to="/" className="inline-block mt-8 text-[12px] tracking-[0.25em] uppercase text-lux-ink border-b border-lux-ink pb-1">Return Home</Link>
      </div>
    </div>
  );
}

function App() {
  return (
    <div className="App font-sans">
      <BrowserRouter>
        <AuthProvider>
          <SettingsProvider>
            <ScrollToTop />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/projects/:id" element={<ProjectDetail />} />
              <Route path="/journal" element={<Journal />} />
              <Route path="/journal/:id" element={<JournalDetail />} />
              <Route path="/bespoke" element={<Bespoke />} />
              <Route path="/experience" element={<Experience />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/gifting" element={<Gifting />} />
              <Route path="/gifting/curated" element={<GiftingCurated />} />
              <Route path="/gifting/:category" element={<GiftingCategory />} />
              <Route path="/understanding-yu" element={<UnderstandingYu />} />
              <Route path="/1618" element={<HiddenRatio />} />
              <Route path="/login" element={<Login />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/cookies" element={<Cookies />} />
              <Route path="/service-terms" element={<ServiceTerms />} />
              <Route path="/intellectual-property" element={<IntellectualProperty />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
            <WhatsNewFAB />
          </SettingsProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
